import Vue from 'vue'
import axios from 'axios'
import { mapState } from 'vuex'

import ImageLink from '@/components/image-link/image-link.vue'
import PlanList from '../components/plan_list.vue'

import { getContent } from '@/api/content'
import { getCoupon } from '@/api/coupon'
import { getIntentSecret } from '@/api/stripe'

const stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY, {
  locale: 'en'
})
const elements = stripe.elements()
let card = undefined

export default Vue.extend({
  name: 'BuyPlan',
  components: {
    PlanList,
    ImageLink
  },
  data() {
    return {
      content: undefined,
      paymentOption: '',
      backRoute: '',
      userToken: localStorage.getItem('token'),
      selectedPlanId: this.$route.params.plan_id,
      agreed: false,
      paymentURL: process.env.VUE_APP_TERMS_OF_PURCHASE,
      isShow: false,
      isDisabled: true,
      couponsCode: '',
      coupons: {
        message: '',
        discount_price: '',
        code: undefined
      },
      customClass: '',
      showPointTable: false
    }
  },
  created() {
    this.fetchData()
    const currentDate = new Date()
    const id = this.$route.params.id
    const contracts = this.user.contracts
    for (let index = 0; index < contracts.length; index++) {
      const contract = contracts[index]
      if (contract.content_id === id) {
        const isExpired = new Date(contract.expire_at)
        if (currentDate <= isExpired) {
          this.$router.push({ path: `/` })
        }
      }
    }
  },
  mounted() {
    this.createCard()
  },
  beforeDestroy() {
    card.destroy(this.$refs.stripe)
  },
  computed: {
    ...mapState(['loading', 'user']),
    valid() {
      if (this.paymentOption) {
        return true
      }
    },
    priceAfterDiscount() {
      return this.coupons.discount_price
        ? this.coupons.discount_price
        : this.content.plans[0].price
    }
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('loading')
      const res = await getContent(+this.$route.params.id).catch(err => {
        if (err.response && err.response.status === 404) {
          this.$router.push({ path: `/contents/${this.$route.params.id}` })
          return
        }
        throw err
      })

      if (!res) {
        return
      }
      this.content = res.data
      if (this.content.limit_purchase_message) {
        this.$router.push({ path: '/' })
        return
      }
      this.content.plans = res.data.plans.filter(
        v => v.id === Number(this.$route.params.plan_id)
      )
      this.$store.dispatch('setTitle', this.content.title)
      this.$store.dispatch('loading', false)
    },
    createCard() {
      const style = {
        base: {
          color: '#32325d'
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
      card = elements.create('card', { style: style })
      card.mount(this.$refs.stripe)
      card.on('change', function(event) {
        let displayError = document.getElementById('card-errors')
        if (event.error) {
          displayError.color = 'red'
          displayError.textContent = event.error.message
          document.getElementsByClassName('btn-submit')[0].disabled = true
        } else {
          document.getElementsByClassName('btn-submit')[0].disabled = false
          displayError.textContent = ''
        }
      })
      const form = document.getElementById('payment-form')

      // Click Purchase button
      form.addEventListener('submit', event => {
        event.preventDefault()
        this.$store.dispatch('loading', true)

        // Get Stripe Secret token
        getIntentSecret(this.selectedPlanId, this.coupons.code).then(res => {
          const returnPath = `/payment/${this.$route.params.id}/complete`

          if (res.client_secret === 'test') {
            this.$store.dispatch('loading', false)

            this.$notify({
              title: '成功',
              text: 'お支払いは正常に処理されました',
              type: 'success'
            })
            this.$router.push({
              path: returnPath
            })
          } else {
            stripe
              .confirmCardPayment(res.client_secret, {
                payment_method: { card: card }
              })
              .then(result => {
                this.$store.dispatch('loading', false)

                if (result.error) {
                  this.$notify({
                    title: 'エラー',
                    text: 'お支払い中にエラーが発生しました',
                    type: 'error'
                  })
                } else {
                  this.$notify({
                    title: '成功',
                    text: 'お支払いは正常に処理されました',
                    type: 'success'
                  })
                  this.$router.push({
                    path: returnPath
                  })
                }
              })
              .catch(e => {
                console.log(e)
                this.$store.dispatch('loading', false)
                this.$notify({
                  title: 'エラー',
                  text: 'お支払い中にエラーが発生しました',
                  type: 'error'
                })
              })
          }
        })
      })

      const script = document.createElement('script')
      const clientID = process.env.VUE_APP_PAYPAL_CLIENT_ID
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientID}&currency=JPY&disable-funding=card`
      script.addEventListener('load', this.setLoaded)
      document.body.appendChild(script)
    },
    choose({ id }) {
      this.selectedPlanId = id
    },
    // PayPay(ペイペイ)の決済開始
    onClickPaypayPaymentBtn() {
      this.$store.dispatch('loading')
      const axiosConfig = {
        headers: {
          Authorization: `Bearer ${this.userToken}`
        }
      }
      const data = {
        coupon_code: this.coupons.code
      }

      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}/paypay_042ce1d98e7099d76917/create_payment?plan_id=${this.selectedPlanId}`,
          data,
          axiosConfig
        )
        .then(res => {
          // Paypayの決済画面に移動
          window.open(res.data.data.paypay_payment_url, '_self')
        })
        .catch(e => {
          this.$store.dispatch('loading', false)
          this.$notify({
            title: 'エラー',
            text: '決済の開始に失敗しました。',
            type: 'error'
          })
        })
    },
    setLoaded: function() {
      this.$nextTick(function() {
        let isRender = false
        let buttons
        if (buttons && buttons.close && isRender) {
          buttons.close()
          isRender = false
        }
        buttons = window.paypal.Buttons({
          env: 'sandbox',
          locale: 'ja_JP',
          style: {
            size: 'small',
            color: 'blue',
            shape: 'pill',
            label: 'checkout'
          },
          createOrder: () => {
            this.$store.dispatch('loading')
            const axiosConfig = {
              headers: {
                Authorization: `Bearer ${this.userToken}`
              }
            }
            const data = {
              coupon_code: this.coupons.code
            }
            return axios
              .post(
                `${process.env.VUE_APP_API_BASE_URL}/paypal_042ce1d98e7099d76917/create_payment?plan_id=${this.selectedPlanId}`,
                data,
                axiosConfig
              )
              .then(res => {
                this.$store.dispatch('loading', false)
                return res.data.data.token
              })
          },
          onApprove: result => {
            this.$store.dispatch('loading')
            const axiosConfig = {
              headers: {
                Authorization: `Bearer ${this.userToken}`
              }
            }
            const data = {
              payment_id: result.paymentID,
              payer_id: result.payerID,
              coupon_code: this.coupons.code
            }
            return axios
              .post(
                `${process.env.VUE_APP_API_BASE_URL}/paypal_042ce1d98e7099d76917/execute_payment?`,
                data,
                axiosConfig
              )
              .then(() => {
                this.$notify({
                  title: '成功',
                  text: 'お支払いは正常に処理されました',
                  type: 'success'
                })
                setTimeout(() => {
                  this.$router.push({
                    path: `/payment/${this.$route.params.id}/complete`
                  })
                  this.$store.dispatch('loading', false)
                }, 500)
              })
              .catch(() => {
                this.$store.dispatch('loading', false)
                this.$notify({
                  title: 'エラー',
                  text: 'お支払い中にエラーが発生しました',
                  type: 'error'
                })
              })
          }
        })
        buttons
          .render(this.$refs.paypal)
          .then(() => {
            isRender = true
          })
          .catch(err => {
            return err
          })
      })
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true
      } else {
        return false
      }
    },
    async getCoupons() {
      const data = await getCoupon(
        this.couponsCode,
        this.$route.params.plan_id
      ).catch(err => {
        if (err.response && err.response.status === 400) {
          this.$store.dispatch('clearMessage')
          this.coupons.message =
            '申し訳ございません。このクーポンコー ドは期限切れ、またはご指定のプランに対応していません。'
          this.coupons.code = undefined
          this.coupons.discount_price = this.content.plans[0].price
        }
      })
      this.showPointTable = data
      if (!data) {
        this.customClass = 'red--text text-center'
        return
      }
      this.customClass = 'text-right'
      Object.assign(this.coupons, {
        message:
          'クーポン' +
          '「' +
          data.data.name +
          '」' +
          'が適用されました ' +
          '(' +
          data.data.discount_rate +
          '%OFF)。',
        discount_price: data.data.discount_price,
        code: data.data.code
      })
      return this.coupons
    },
    resetInput(e) {
      if (!e) {
        this.coupons.code = undefined
        this.coupons.discount_price = this.content.plans[0].price
        this.showPointTable = false
      }
      this.coupons.message = ''
      this.isDisabled = !e
    }
  }
})
